import React from 'react';
import './About.css';

import { Button, Heading} from '../../../components';
import { about } from '../../../constants';



const About = () => {

  const { sub, heading, experience, description, points, image, button } = about;

  return (
    <section className="about">

      {/* About Image */}
      <div className="image">
        <div className="sub-image">
          <img src={image.src1} alt={image.alt1} />
          <div className='experience'><span><div className='icon'>{experience.icon}</div>{experience.year}</span> {experience.text}</div>
        </div>
        <div className="sub-image last">
          <img src={image.src2} alt={image.alt2} />
        </div>
      </div>

      {/* Introduction Content */}
      <div className="content">

        {/* Section Heading */}
        <Heading title={heading} subTitle={sub} sideHeading />

        {/* Description */}
        {description.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}

        {/* Key Features List */}
        <ul className="about-features">
        {points.map((point, index) => (
            <li key={index}>
              <div className='icon'>{point.icon}</div> {/* Point Icon */}
              <span>{point.title}</span> {/* Point Title */}
            </li>
          ))}
        </ul>

        {/* Button Component: Links to a specific page or action */}
        <Button link={button.link} title={button.text} />

      </div>
    </section>
  );
};

export default About;